// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"443":"about","791":"materials"}[chunkId] || chunkId) + "." + {"267":"469547ec","337":"4ce7133b","443":"2b7feed6","453":"fb00f83c","654":"74776ad6","661":"b34378d5","719":"41fe6204","791":"39211e7c","804":"49dd1955","881":"289dec31","912":"6c588738"}[chunkId] + ".js";
};